import { FormControl } from "@chakra-ui/form-control";
import { Flex, FlexProps, Grid } from "@chakra-ui/react";
import { useFormikContext } from "formik";
import { InputControl } from "formik-chakra-ui";
import { FormikSwitchInput } from "src/components/Inputs/FormikSwitchInput";
import { STATUS_ACTIVE, STATUS_CLOSED } from "src/constants";
import useRequiredHasuraRoles from "src/hooks/useRequiredHasuraRoles";
import {
  generateKey,
  isUserGeneratedKey,
} from "src/scenes/orgAdmin/formTemplates/ContentTab/V2/autoGenerateKey";
import { SchoolFormType } from "src/schemas/School";
import type { GlossaryFn } from "src/types/glossary";
import { HasuraRole } from "src/types/hasuraRole";
import { AddressForm } from "./AddressForm";

type Props = FlexProps & { glossary: GlossaryFn };
export const SchoolForm = ({ glossary, ...props }: Props) => {
  const isEditEnabled = useRequiredHasuraRoles([
    HasuraRole.ADMIN,
    HasuraRole.ORG_ADMIN,
  ]);
  const formik = useFormikContext<SchoolFormType>();

  return (
    <Flex direction="column" gap={4} {...props}>
      <Grid
        gridTemplateColumns="repeat(auto-fit, minmax(15rem, 1fr))"
        gap={3}
        alignItems="flex-start"
      >
        <InputControl
          inputProps={{
            placeholder: glossary`E.g.: Lincoln School`,
            onChange: async (event) => {
              const name = event.target.value;
              const shouldChangeReferenceId = !isUserGeneratedKey(
                formik.values.reference_id,
                formik.values.name
              );

              await formik.setFieldValue("name", name, false);
              if (shouldChangeReferenceId) {
                await formik.setFieldValue(
                  "reference_id",
                  generateKey(name),
                  false
                );
              }
            },
          }}
          name="name"
          label="Name"
          isRequired
          labelProps={{ requiredIndicator: <></> }}
        />
        <InputControl
          isRequired
          inputProps={{
            placeholder: "E.g.: 12345678",
            onChange: async (event) => {
              await formik.setFieldValue("reference_id", event.target.value);
            },
          }}
          name="reference_id"
          id="reference_id"
          label="Reference ID"
          isDisabled={!isEditEnabled}
          labelProps={{ requiredIndicator: <></> }}
        />
      </Grid>
      <AddressForm />

      <FormControl display="flex">
        <FormikSwitchInput<string>
          label="Status"
          name="status"
          checked={STATUS_ACTIVE}
          unchecked={STATUS_CLOSED}
        />
      </FormControl>
    </Flex>
  );
};
